import { gql } from 'apollo-angular';

export const RemoveBaseWorkFlow = gql`
  mutation RemoveBaseWorkFlow($id: Int!) {
    removeBaseWorkFlow(id: $id)
  }
`;
